const uk = {
  10000001: 'Святкування другої річниці SuperEx',
  10000002: 'Реєструйтеся, щоб отримати чудові нагороди!',
  10000003: 'Розблокуйте відповідний призовий фонд відповідно до кількості учасників; чим більше учасників, тим більший призовий фонд, до 10,000 USDT',
  10000004: 'Святкування другої річниці SuperEx',
  10000005: 'Виграйте 20 000 USDT у конкурсі ф’ючерсної торгівлі',
  10000006: `Змагання за обсягом торгів, розблокуйте призовий фонд до <span style="color: #ffc72b;">10,000</span> USDT`,
  10000007: 'Чемпіонат з ф\'ючерсів',
  10000008: 'Виграйте 20 000 USDT у конкурсі ф’ючерсної торгівлі',
}
export default uk



// WEBPACK FOOTER //
// ./src/i18n/langs/languageGaea/uk.js